/* JungleSocks · Performance — galería de fotos en las tarjetas del configurador de packs (CMC 23102026)
   - Cada tarjeta: carrusel con scroll-snap (se desliza en móvil, flechas en escritorio) y puntos de posición.
   - Al tocar una foto se abre el visor a pantalla completa (<dialog>): flechas, teclado (← →, Esc) y deslizar.
   No toca la lógica del configurador (perf-pack-builder.js): sus botones no usan data-nav, data-zoom ni data-lb-*. */
(function () {
  function smooth() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }
  function idx(track) {
    return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function onScroll(el, fn) {
    var raf = 0;
    el.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; fn(); });
    }, { passive: true });
  }
  function syncCard(track) {
    var media = track.parentNode;
    var n = track.children.length;
    var k = idx(track);
    media.querySelectorAll('.ppb__dots i').forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
    var prev = media.querySelector('[data-nav="-1"]');
    var next = media.querySelector('[data-nav="1"]');
    if (prev) prev.classList.toggle('is-off', k <= 0);
    if (next) next.classList.toggle('is-off', k >= n - 1);
  }

  function init(root) {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = '1';

    root.querySelectorAll('[data-track]').forEach(function (track) {
      onScroll(track, function () { syncCard(track); });
    });

    var lb = root.querySelector('[data-lb]');
    var lbTrack = lb ? lb.querySelector('[data-lb-track]') : null;
    var lbCount = lb ? lb.querySelector('[data-lb-count]') : null;
    var lbTitle = lb ? lb.querySelector('[data-lb-title]') : null;
    var lbPrev = lb ? lb.querySelector('[data-lb-nav="-1"]') : null;
    var lbNext = lb ? lb.querySelector('[data-lb-nav="1"]') : null;
    var opener = null;

    function lbSync() {
      var n = lbTrack.children.length;
      var k = idx(lbTrack);
      lbCount.textContent = n > 1 ? (k + 1) + ' / ' + n : '';
      lbPrev.classList.toggle('is-off', k <= 0);
      lbNext.classList.toggle('is-off', k >= n - 1);
    }
    function onClose() {
      document.documentElement.classList.remove('ppb-lb-open');
      lbTrack.innerHTML = '';
      if (opener) {
        try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
        opener = null;
      }
    }
    function closeLb() {
      if (typeof lb.close === 'function') lb.close();
      else { lb.removeAttribute('open'); onClose(); }
    }
    function openLb(card, start, trigger) {
      var slides = card.querySelectorAll('[data-full]');
      if (!slides.length) return;
      lbTrack.innerHTML = Array.prototype.map.call(slides, function (s, j) {
        var img = s.querySelector('img');
        return '<div class="ppb__lb-slide"><img src="' + esc(s.dataset.full) + '" alt="' + esc(img ? img.alt : '') + '"' +
          (Math.abs(j - start) > 1 ? ' loading="lazy"' : '') + '></div>';
      }).join('');
      var name = card.querySelector('.ppb__name');
      lbTitle.textContent = name ? name.textContent : '';
      opener = trigger || null;
      if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
      document.documentElement.classList.add('ppb-lb-open');
      lbTrack.scrollLeft = start * lbTrack.clientWidth;
      lbSync();
    }

    root.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-nav]');
      if (nav && root.contains(nav)) {
        var track = nav.parentNode.querySelector('[data-track]');
        if (track) track.scrollBy({ left: +nav.dataset.nav * track.clientWidth, behavior: smooth() });
        return;
      }
      var slide = e.target.closest('[data-zoom]');
      if (slide && lb && root.contains(slide)) {
        openLb(slide.closest('.ppb__card'), +slide.dataset.zoom, slide);
      }
    });

    if (!lb) return;
    lb.addEventListener('close', onClose);
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('[data-lb-close]')) { closeLb(); return; }
      var nav = e.target.closest('[data-lb-nav]');
      if (nav) lbTrack.scrollBy({ left: +nav.dataset.lbNav * lbTrack.clientWidth, behavior: smooth() });
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      lbTrack.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * lbTrack.clientWidth, behavior: smooth() });
    });
    onScroll(lbTrack, lbSync);
  }

  function boot() { document.querySelectorAll('[data-ppb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
